import React from 'react';
import type { HelpCenterSettingsCustomerAccess as HelpCenterSettingsCustomerAccessType } from '@atlassian/jira-spa-apps-help-center-settings-customer-access/src/ui/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyHelpCenterSettingsCustomerAccess = lazyForPaint<
	typeof HelpCenterSettingsCustomerAccessType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-help-center-settings-customer-access", jiraSpaEntry: "async-help-center-settings-customer-access" */ '@atlassian/jira-spa-apps-help-center-settings-customer-access'
		),
	),
);

export const HelpCenterSettingsCustomerAccess = () => (
	<LazyPage
		Page={LazyHelpCenterSettingsCustomerAccess}
		pageId="help-center-settings-customer-access"
		shouldShowSpinner
	/>
);
